import { DisplayItem } from 'design-system';

export const LEASING = 'L';
export const BANK = 'A';
export const NONE = 'N';

export const list: DisplayItem[] = [
  { Value: LEASING, Text: 'Leasing' },
  { Value: BANK, Text: 'Acreedor (préstamo bancario)' },
  { Value: NONE, Text: 'Ninguno' },
];

export const defaultValue = NONE;
export const withBanksValues = [LEASING, BANK];
